import image1 from "../images/couple-with-dog-facebook-post.jpg";
import image2 from "../images/couple-with-dog-instagram-post.jpg";
import image3 from "../images/couple-with-dog-story.jpg";

import image4 from "../images/family-of-four-facebook-post.jpg";
import image5 from "../images/family-of-four-instagram-post.jpg";
import image6 from "../images/family-of-four-story.jpg";

import image7 from "../images/family-of-three-facebook-post.jpg";
import image8 from "../images/family-of-three-instagram-post.jpg";
import image9 from "../images/family-of-three-story.jpg";

import image10 from "../images/older-couple-facebook-post.jpg";
import image11 from "../images/older-couple-instagram-post.jpg";
import image12 from "../images/older-couple-story.jpg";

import image13 from "../images/young-couple-facebook-post.jpg";
import image14 from "../images/young-couple-instagram-post.jpg";
import image15 from "../images/young-couple-story.jpg";

const imageOptions = [
  { id: 1, src: image1, name: "couple-with-dog", type: "facebook-post" },
  {
    id: 2,
    src: image2,
    ig: true,
    name: "couple-with-dog",
    type: "instagram-post",
  },
  { id: 3, src: image3, name: "couple-with-dog", type: "story" },
  { id: 4, src: image4, name: "family-of-four", type: "facebook-post" },
  {
    id: 5,
    src: image5,
    ig: true,
    name: "family-of-four",
    type: "instagram-post",
  },
  { id: 6, src: image6, name: "family-of-four", type: "story" },
  { id: 7, src: image7, name: "family-of-three", type: "facebook-post" },
  {
    id: 8,
    src: image8,
    ig: true,
    name: "family-of-three",
    type: "instagram-post",
  },
  { id: 9, src: image9, name: "family-of-three", type: "story" },
  { id: 10, src: image10, name: "older-couple", type: "facebook-post" },
  {
    id: 11,
    src: image11,
    ig: true,
    name: "older-couple",
    type: "instagram-post",
  },
  { id: 12, src: image12, name: "older-couple", type: "story" },
  { id: 13, src: image13, name: "young-couple", type: "facebook-post" },
  {
    id: 14,
    src: image14,
    ig: true,
    name: "young-couple",
    type: "instagram-post",
  },
  { id: 15, src: image15, name: "young-couple", type: "story" },
];

export default imageOptions;
